import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class SetFordrojningSkotningCommand extends BasicCommand<SetFordrojningSkotningCommand> {
    get primaryKey(): IPrimaryKey<SetFordrojningSkotningCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    angivenFordrojningSkotning?: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetFordrojningSkotningCommand";
    constructor(init: (instance: SetFordrojningSkotningCommand) => void) {
        super(SetFordrojningSkotningCommand.$type, SetFordrojningSkotningCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
